import { useCallback, useEffect, useState } from 'react';
import { useTheme } from 'styled-components';

export const useSideBar = () => {
  const theme = useTheme();
  const isManuallyCollapsed =
    sessionStorage.getItem('isManuallyCollapsed') === 'true';
  const [isCollapsed, setIsCollapsed] = useState(
    window.innerWidth < theme.screenMD ? true : isManuallyCollapsed,
  );

  const checkSize = useCallback(() => {
    if (isManuallyCollapsed && window.innerWidth >= theme.screenMD) return;
    if (window.innerWidth < theme.screenMD) {
      setIsCollapsed(true);
    } else {
      setIsCollapsed(false);
    }
  }, [theme.screenMD, isManuallyCollapsed]);

  useEffect(() => {
    checkSize();
    window.addEventListener('resize', checkSize);

    return () => {
      window.removeEventListener('resize', checkSize);
    };
  }, [checkSize]);

  const toggleCollapsed = useCallback(() => {
    setIsCollapsed((prev) => {
      const newState = !prev;
      sessionStorage.setItem('isManuallyCollapsed', newState.toString());
      return newState;
    });
  }, []);

  return { isCollapsed, toggleCollapsed };
};
